import { QUERY_KEYS } from 'api/query-keys';
import { partnerPlacementService } from 'partner/shared/services';
import { useMutation, useQueryClient } from 'react-query';

type CancelShiftPlacementsParams = {
  placementIds: string[];
};

export const useCancelShiftPlacements = () => {
  const mutationFn = async ({ placementIds }: CancelShiftPlacementsParams) =>
    await partnerPlacementService.cancelShiftPlacements(placementIds);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  });
};
